
export enum ReportStatus {
  IDLE = 'IDLE',
  LOADING = 'LOADING',
  STREAMING = 'STREAMING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR'
}

export interface Source {
  title: string;
  url: string;
}

export interface ReportData {
  markdown: string;
  sources: Source[];
}

export interface NewsItem {
  title: string;
  entity: string;
  summary: string;
  facts: string[];
  opinions: string[];
  explanation: string;
  link: string;
}
